import GoogleStreetViewImagePopup from './GoogleStreetViewImagePopup-redux';

export default GoogleStreetViewImagePopup;
